//import React from 'react';
import Login from '../views/login';
import Home from '../views/home';
import ExpotacaoDados from '../views/exportacaoDados';
import GeracaoAta from '../views/geracaoAta';
import ConsultaAta from '../views/consultaAta';
import { AuthConsumer } from '../main/provedorAutenticacao';


import {
  Route,
  Switch,
  HashRouter,
  Redirect,
  useLocation,
} from 'react-router-dom';
import Navbar from '../components/navbar';
import EmpresasRecuperacaoJudicial from '../views/empresasRecuperacaoJudicial';
import EmpresasFalidas from '../views/empresasFalidas';
import GerarEtiquetaArquivamento from '../views/gerarEtiquetaArquivamento';

function RotaAutenticada({ component: Component, isUsuarioAutenticado, ...props }) {
  return (
    <Route
      exact
      {...props}
      render={(componentProps) => {
        if (isUsuarioAutenticado) {
          return <Component {...componentProps} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: componentProps.location },
              }}
            />
          );
        }
      }}
    />
  );
}

function RotasInternas(props) {
  const location = useLocation();
  const isLoginPage =
    location.pathname === '/login' || location.pathname === '/';

  return (
    <Navbar showSidebar={!isLoginPage}>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/login" component={Login} />

        <RotaAutenticada
          isUsuarioAutenticado={props.isUsuarioAutenticado}
          path="/home"
          component={Home}
        />
        <RotaAutenticada
          isUsuarioAutenticado={props.isUsuarioAutenticado}
          path="/exportacao-dados"
          component={ExpotacaoDados}
        />
        <RotaAutenticada
          isUsuarioAutenticado={props.isUsuarioAutenticado}
          path="/geracao-ata"
          component={GeracaoAta}
        />
        <RotaAutenticada
          isUsuarioAutenticado={props.isUsuarioAutenticado}
          path="/consulta-ata"
          component={ConsultaAta}
        />
        <RotaAutenticada
          isUsuarioAutenticado={props.isUsuarioAutenticado}
          path="/empresas-recuperacao-judicial"
          component={EmpresasRecuperacaoJudicial}
        />

        <RotaAutenticada 
          isUsuarioAutenticado={props.isUsuarioAutenticado}
          path="/empresas-falidas"
          component={EmpresasFalidas}
        />
        <RotaAutenticada 
          isUsuarioAutenticado={props.isUsuarioAutenticado}
          path="/etiquetas"
          component={GerarEtiquetaArquivamento}
        />

      </Switch>
    </Navbar>
  );
}

function Rotas(props) {
  return (
    <HashRouter>
      <RotasInternas {...props} />
    </HashRouter>
  );
}

export default () => (
  <AuthConsumer>
    {(context) => <Rotas isUsuarioAutenticado={context.isAutenticado} />}
  </AuthConsumer>
);
